import withEdit from '../../Formik/with-edit'
import Default from './Default'
import Edit from './Edit'

export default withEdit( Default, Edit )

